module.exports = __webpack_public_path__ + "img/路径 2315@2x.6f767a8c.png";